__webpack_require__.p = "https://static-jp.theckb.com/prod-ckb-easy-h5-fed-3fbox/present/";